import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { PrintService } from 'src/app/core/services/print.service';
import { Case } from '../models/cases/case';
import { Client } from '../models/clients/client';
import { RejectRequestModalComponent } from '../reject-request-modal/reject-request-modal.component';

@Component({
  selector: 'app-client-summary-modal',
  templateUrl: './client-summary-modal.component.html',
  styleUrls: ['./client-summary-modal.component.scss']
})
export class ClientSummaryModalComponent implements OnInit {
  clientInfo: Client;
  @ViewChild('clientSummaryModal') clientSummaryModal;
  modalRef: NgbModalRef;
  @ViewChild('rejectModal') rejectModal: RejectRequestModalComponent;
  @Output() submit: EventEmitter<Client> = new EventEmitter<Client>();
  constructor(
    private modalService: NgbModal,
    private clientsApi: ClientsApiService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private printService: PrintService,
  ) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(client: Client) {
    this.clientInfo = client;
    this.modalRef = this.modalService.open(this.clientSummaryModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  acceptRequest() {
    this.spinner.show();
    this.clientsApi.acceptNewClient(this.clientInfo.id).subscribe(
      r => {
        this.submit.emit(this.clientInfo);
        this.close();
        this.spinner.hide();
        this.toastr.success(`Client #${this.clientInfo.name} is now approved`, 'Approved!');
      }
    )
  }

  rejectRequest() {
    this.rejectModal.open();
  }

  sendRejectionReason(reason: string) {
    this.spinner.show();
    this.clientsApi.rejectNewClient(this.clientInfo.id, reason).subscribe(
      r => {
        this.submit.emit(this.clientInfo);
        this.close();
        this.spinner.hide();
        this.toastr.success('Rejection message sent.', 'Done!');
      }
    )
  }

  onPrint() {
    this.printService.data = this.clientInfo;
    this.printService.printDocument('client-summary');
  }

}
